import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { ensureElementVisible } from "@/lib/route-guards";

const DzzfAssignmentsPage = lazy(() =>
	import("@/features/dzzf/dzzf-assignments-page").then((m) => ({
		default: m.DzzfAssignmentsPage,
	})),
);

export const Route = createFileRoute("/_auth/kontrakty/apteki-producentow")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.apteki-producentow",
			location.pathname,
		);
	},
	component: DzzfAssignmentsPage,
});
